(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Manifest steppers: adjust the updates[] input then submit the cart form
     (plain document POST — same mechanism as the no-JS Update button).
     No JS-driven motion here, so no reduced-motion guard is required. */
  (function () {
    function init() {
      var roots = document.querySelectorAll('[data-manifest]');
      roots.forEach(function (root) {
        var form = root.querySelector('.manifest__form');
        if (!form) return;

        var submitForm = function () {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        };

        root.querySelectorAll('.manifest__step').forEach(function (button) {
          button.addEventListener('click', function () {
            var stepper = button.closest('.manifest__stepper');
            var input = stepper ? stepper.querySelector('.manifest__qty-input') : null;
            if (!input) return;
            var current = parseInt(input.value, 10);
            if (isNaN(current)) current = 0;
            var next = current + (button.getAttribute('data-step') === 'down' ? -1 : 1);
            if (next < 0) next = 0;
            input.value = next;
            submitForm();
          });
        });

        root.querySelectorAll('.manifest__qty-input').forEach(function (input) {
          input.addEventListener('change', submitForm);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creed"]) return;
  try {
    
  document.querySelectorAll('[data-creed]').forEach((root) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const film = root.querySelector('[data-creed-film]');
    if (film) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            film.play().then(() => film.classList.add('is-playing')).catch(() => {});
          } else {
            film.pause();
          }
        });
      }, { threshold: 0.15 });
      io.observe(film);
    }

    // stanza-by-stanza brightening through the middle band of the viewport
    const stanzas = [...root.querySelectorAll('.creed__body p')];
    if (stanzas.length) {
      root.classList.add('creed--stanza-motion');
      let fired = false;
      const lit = new IntersectionObserver((entries) => {
        fired = true;
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-lit', entry.isIntersecting);
        });
      }, { rootMargin: '-25% 0px -25% 0px' });
      stanzas.forEach((p) => lit.observe(p));
      // house watchdog: if the observer never reports, never leave text dimmed
      setTimeout(() => {
        if (!fired) {
          lit.disconnect();
          root.classList.remove('creed--stanza-motion');
        }
      }, 1200);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discover-band"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-discover]').forEach((root) => {
    // V2.6: multiple openers (desktop band + mobile tile) share one modal
    const openBtns = [...root.querySelectorAll('[data-film-open]')];
    const modal = root.querySelector('[data-film-modal]');
    let returnFocus = null;

    if (openBtns.length && modal) {
      const closeBtn = modal.querySelector('[data-film-close]');
      const video = modal.querySelector('video');

      const open = (btn) => {
        returnFocus = btn;
        modal.hidden = false;
        modal.classList.add('is-entering');
        modal.offsetHeight;
        modal.classList.remove('is-entering');
        document.documentElement.style.overflow = 'hidden';
        if (video) video.play().catch(() => {});
        closeBtn.focus();
      };

      const close = () => {
        if (modal.hidden) return;
        if (video) video.pause();
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (returnFocus) returnFocus.focus();
      };

      openBtns.forEach((btn) => btn.addEventListener('click', () => open(btn)));
      closeBtn.addEventListener('click', close);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
      // trap Tab between the modal's two focusables (same cycle as the
      // gallery lightbox) — aria-modal promises focus stays inside
      modal.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const stops = [closeBtn, video].filter(Boolean);
        const last = stops[stops.length - 1];
        if (e.shiftKey && document.activeElement === stops[0]) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          stops[0].focus();
        }
      });
    }

    // V2.6 ambient loop: play only in view, never under reduced motion
    const ambient = root.querySelector('[data-ambient]');
    if (ambient && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            ambient.play().then(() => ambient.classList.add('is-playing')).catch(() => {});
          } else {
            ambient.pause();
          }
        });
      }, { threshold: 0.2 });
      io.observe(ambient);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ftabs').forEach((root) => {
    const tabs = [...root.querySelectorAll('.ftabs__tab')];
    const panels = [...root.querySelectorAll('.ftabs__panel')];
    const activate = (tab, focus) => {
      const i = tab.dataset.tab;
      tabs.forEach((t) => {
        const selected = t === tab;
        t.classList.toggle('is-active', selected);
        t.setAttribute('aria-selected', selected);
        t.tabIndex = selected ? 0 : -1;
      });
      if (focus) tab.focus();
      panels.forEach((p) => {
        const active = p.dataset.panel === i;
        if (active && p.hidden) {
          p.hidden = false;
          p.classList.add('is-entering');
          p.offsetHeight;
          p.classList.remove('is-entering');
        } else if (!active) {
          p.hidden = true;
        }
        p.classList.toggle('is-active', active);
      });
    };
    /* V2.71: mobile stacks every panel; desktop keeps the tabs. */
    const stackQuery = window.matchMedia('(max-width: 989.98px)');
    const applyLayout = () => {
      if (stackQuery.matches) {
        root.classList.add('ftabs--stacked');
        panels.forEach((p) => {
          p.hidden = false;
          p.classList.add('is-active');
        });
      } else {
        root.classList.remove('ftabs--stacked');
        activate(tabs.find((t) => t.classList.contains('is-active')) || tabs[0], false);
      }
    };
    applyLayout();
    if (stackQuery.addEventListener) stackQuery.addEventListener('change', applyLayout);
    else stackQuery.addListener(applyLayout);

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (e) => {
        let target = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') target = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') target = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') target = tabs[0];
        if (e.key === 'End') target = tabs[tabs.length - 1];
        if (target) {
          e.preventDefault();
          activate(target, true);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gallery-wall')) {
    class GalleryWall extends HTMLElement {
      connectedCallback() {
        // living plates: play in view only, never under reduced motion
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
          const films = [...this.querySelectorAll('[data-gallery-film]')];
          if (films.length) {
            const io = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.play().then(() => entry.target.classList.add('is-playing')).catch(() => {});
                } else {
                  entry.target.pause();
                }
              });
            }, { threshold: 0.2 });
            films.forEach((f) => io.observe(f));
          }
        }

        this.lightbox = this.querySelector('[data-gallery-lightbox]');
        if (!this.lightbox) return;
        this.lightboxImg = this.lightbox.querySelector('[data-gallery-img]');
        this.lightboxCaption = this.lightbox.querySelector('[data-gallery-caption]');
        this.closeBtn = this.lightbox.querySelector('[data-gallery-close]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.querySelectorAll('[data-gallery-open]').forEach((plate) => {
          plate.addEventListener('click', () => this.open(plate));
        });

        this.closeBtn.addEventListener('click', () => this.close());
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox) this.close();
        });
        // keep Tab inside the dialog (close button <-> video when playing)
        this.lightbox.addEventListener('keydown', (e) => {
          if (e.key !== 'Tab') return;
          const video = this.lightbox.querySelector('[data-gallery-video]');
          const focusables = video && !video.hidden ? [this.closeBtn, video] : [this.closeBtn];
          if (focusables.length === 1) {
            e.preventDefault();
            this.closeBtn.focus();
            return;
          }
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
        this.onDocKeydown = (e) => {
          if (e.key === 'Escape' && !this.lightbox.hidden) this.close();
        };
        document.addEventListener('keydown', this.onDocKeydown);
      }

      disconnectedCallback() {
        if (this.onDocKeydown) document.removeEventListener('keydown', this.onDocKeydown);
      }

      open(plate) {
        const video = this.lightbox.querySelector('[data-gallery-video]');
        if (plate.dataset.video && video) {
          // living plate: play it full-screen with sound and controls
          this.lightboxImg.hidden = true;
          video.hidden = false;
          video.src = plate.dataset.video;
          video.play().catch(() => {});
        } else {
          if (video) {
            video.pause();
            video.hidden = true;
          }
          this.lightboxImg.hidden = false;
          const thumb = plate.querySelector('img');
          this.lightboxImg.src = plate.dataset.full || (thumb && (thumb.currentSrc || thumb.src)) || '';
          this.lightboxImg.alt = (thumb && thumb.alt) || '';
        }
        const caption = plate.dataset.caption || '';
        this.lightboxCaption.textContent = caption;
        this.lightboxCaption.hidden = caption === '';
        this.returnFocus = plate;
        this.lightbox.hidden = false;
        if (!this.reduceMotion.matches) {
          this.lightbox.classList.add('is-entering');
          this.lightbox.offsetHeight;
          this.lightbox.classList.remove('is-entering');
        }
        document.documentElement.style.overflow = 'hidden';
        this.closeBtn.focus();
      }

      close() {
        const video = this.lightbox.querySelector('[data-gallery-video]');
        if (video) video.pause();
        this.lightbox.hidden = true;
        document.documentElement.style.overflow = '';
        if (this.returnFocus) this.returnFocus.focus();
      }
    }
    customElements.define('gallery-wall', GalleryWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav extends HTMLElement {
    connectedCallback() {
      this.openDrawer = null;
      this.closeTimer = null;
      this.abort = new AbortController();
      const { signal } = this.abort;

      // desktop drawers — hover-intent: a short delay before opening so a
      // mouse passing through (or leaving after a click) never re-opens one
      this.openTimer = null;
      this.suppressUntil = 0;
      this.querySelectorAll('[data-drawer-trigger]').forEach((link) => {
        const key = link.getAttribute('data-drawer-trigger');
        const drawer = this.querySelector(`[data-drawer="${key}"]`);
        if (!drawer) return;
        link.addEventListener(
          'mouseenter',
          () => {
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => this.open(link, drawer), 140);
          },
          { signal }
        );
        link.addEventListener('mouseleave', () => clearTimeout(this.openTimer), { signal });
        // keyboard focus opens immediately; mouse clicks don't match :focus-visible
        link.addEventListener(
          'focus',
          () => {
            if (link.matches(':focus-visible')) this.open(link, drawer);
          },
          { signal }
        );
        // clicking a trigger navigates — close and stay closed on the way out
        link.addEventListener(
          'click',
          () => {
            clearTimeout(this.openTimer);
            this.suppressUntil = Date.now() + 2000;
            this.close();
          },
          { signal }
        );
      });
      this.addEventListener('mouseleave', () => this.scheduleClose(), { signal });
      this.addEventListener('mouseenter', () => clearTimeout(this.closeTimer), { signal });
      // V2.6 (Josh): hovering any non-trigger part of the bar (logo, icons,
      // empty bar) closes an open drawer; re-entering a trigger or the
      // drawer itself cancels the pending close (150ms transit grace)
      this.addEventListener(
        'mouseover',
        (e) => {
          if (!this.openDrawer) return;
          if (e.target.closest('[data-drawer-trigger]') || e.target.closest('.header-drawer')) {
            clearTimeout(this.closeTimer);
          } else {
            this.scheduleClose();
          }
        },
        { signal }
      );
      // close the drawer when keyboard focus leaves the header entirely
      this.addEventListener(
        'focusout',
        () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) this.close();
          });
        },
        { signal }
      );
      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Escape') {
            this.close();
            this.closeMobile();
          }
        },
        { signal }
      );

      // solid tint once the bar leaves the top of the page
      this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 24);
      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      this.onScroll();

      // mobile toggle
      this.toggle = this.querySelector('.site-header__toggle');
      this.mobileDrawer = this.querySelector('.mobile-drawer');
      if (this.toggle) {
        this.toggle.addEventListener(
          'click',
          () => {
            if (this.classList.contains('is-mobile-open')) {
              this.closeMobile();
            } else {
              this.openMobile();
            }
          },
          { signal }
        );
      }

      // rotate/resize past 990px hides the drawer and its toggle; the scroll
      // lock and inert must not survive that
      const desktopMq = window.matchMedia('(min-width: 990px)');
      desktopMq.addEventListener('change', () => { if (desktopMq.matches) this.closeMobile(); }, { signal });
    }

    disconnectedCallback() {
      this.abort.abort();
    }

    open(link, drawer) {
      if (Date.now() < this.suppressUntil) return;
      clearTimeout(this.closeTimer);
      clearTimeout(drawer._hideTimer); /* a pending hide() from a quick hover-away must not blank a re-opened drawer */
      if (this.openDrawer && this.openDrawer !== drawer) this.hide(this.openDrawer);
      this.querySelectorAll('.site-header__link').forEach((l) => {
        l.classList.remove('is-active');
        l.setAttribute('aria-expanded', 'false');
      });
      link.classList.add('is-active');
      link.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      drawer.hidden = false;
      drawer.offsetHeight; /* force reflow so the fade-in transition runs */
      drawer.classList.add('is-visible');
      this.openDrawer = drawer;
    }

    hide(drawer) {
      drawer.classList.remove('is-visible');
      drawer._hideTimer = setTimeout(() => (drawer.hidden = true), 200);
    }

    scheduleClose() {
      this.closeTimer = setTimeout(() => this.close(), 150);
    }

    close() {
      if (!this.openDrawer) return;
      this.hide(this.openDrawer);
      this.openDrawer = null;
      this.classList.remove('is-open');
      this.querySelectorAll('.site-header__link').forEach((l) => {
        l.classList.remove('is-active');
        l.setAttribute('aria-expanded', 'false');
      });
    }

    openMobile() {
      this.classList.add('is-mobile-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.mobileDrawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      // keep keyboard/AT focus inside the drawer while it covers the page
      this.inertTargets = Array.from(document.body.children).filter((el) => !el.contains(this));
      this.inertTargets.forEach((el) => el.setAttribute('inert', ''));
    }

    closeMobile() {
      if (!this.classList.contains('is-mobile-open')) return;
      this.classList.remove('is-mobile-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.mobileDrawer.hidden = true;
      document.documentElement.style.overflow = '';
      (this.inertTargets || []).forEach((el) => el.removeAttribute('inert'));
    }
  }

  if (!customElements.get('header-nav')) {
    customElements.define('header-nav', HeaderNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('.pdp__slide')];
      this.progress = this.querySelector('[data-progress]');
      this.index = 0;
      this.desktop = window.matchMedia('(min-width: 990px)');

      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      if (this.track && this.progress) {
        this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true });
        this.updateProgress();
      }

      // V2.6: desktop progress advances per slide (the track transforms
      // rather than scrolling, so the scroll handler never fires there)
      this.syncDesktopProgress = () => {
        if (this.progress && this.desktop.matches && this.slides.length) {
          this.progress.style.width = (((this.index + 1) / this.slides.length) * 100) + '%';
        }
      };
      this.syncDesktopProgress();
      this.desktop.addEventListener('change', () => this.syncDesktopProgress());

      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.go(Number(thumb.dataset.thumb)));
      });

      this.querySelectorAll('[data-accordion]').forEach((acc) => {
        const head = acc.querySelector('.pdp__acc-head');
        head.addEventListener('click', () => {
          const open = acc.classList.toggle('is-open');
          head.setAttribute('aria-expanded', open);
        });
      });

      // V2.6 attach upsell: when checked, add both items via the AJAX API.
      // Any failure falls back to the native single-product submit.
      const form = this.querySelector('.pdp__form');
      const upsellCheck = this.querySelector('[data-upsell-check]');
      // checked state re-prices the button: the label swaps to the pair
      // text Liquid prebuilt into data-pair-label ("<pair label> — <both
      // variants summed>"), and back to the single label when unchecked. The
      // figure is computed server-side, so a reprice never reaches this file.
      const upsellRow = this.querySelector('[data-upsell]');
      const addLabelSpan = form ? form.querySelector('.pdp__add > span:first-child') : null;
      if (upsellCheck && upsellRow && addLabelSpan) {
        const singleText = addLabelSpan.textContent.trim();
        const pairText = upsellRow.dataset.pairLabel;
        if (pairText) {
          upsellCheck.addEventListener('change', () => {
            addLabelSpan.textContent = upsellCheck.checked ? pairText : singleText;
          });
        }
      }
      if (form && upsellCheck) {
        let upsellBusy = false;
        const upsellBtn = form.querySelector('.pdp__add');
        // bfcache: Safari/Chrome restore the page with JS heap intact after
        // back-navigation from /cart — re-arm the buy box
        window.addEventListener('pageshow', (e) => {
          if (e.persisted) {
            upsellBusy = false;
            if (upsellBtn) upsellBtn.disabled = false;
          }
        });
        form.addEventListener('submit', (e) => {
          if (!upsellCheck.checked || upsellBusy) return;
          e.preventDefault();
          upsellBusy = true;
          const main = form.querySelector('input[name="id"]');
          const btn = form.querySelector('.pdp__add');
          if (btn) btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: Number(main.value), quantity: 1 },
                { id: Number(upsellCheck.value), quantity: 1 },
              ],
            }),
          })
            .then((r) => {
              if (!r.ok) throw new Error('cart add failed');
              window.location.href = '/cart';
            })
            .catch(() => {
              upsellCheck.checked = false;
              upsellBusy = false;
              if (btn) btn.disabled = false;
              form.submit();
            });
        });
      }

      this.ambient = this.querySelector('[data-film-ambient]');
      this.ambientInView = false;

      this.lightbox = this.querySelector('[data-lightbox]');
      if (this.lightbox) {
        this.lightboxImg = this.lightbox.querySelector('[data-lightbox-img]');
        this.lightboxClose = this.lightbox.querySelector('[data-lightbox-close]');
        this.lightboxPanel = this.lightbox.querySelector('[data-lightbox-panel]');
        this.filmPanel = this.lightbox.querySelector('[data-lightbox-film]');
        this.filmVideo = this.filmPanel ? this.filmPanel.querySelector('video') : null;
        const show = (opener, label) => {
          this.lightboxReturnFocus = opener;
          this.lightbox.setAttribute('aria-label', label);
          this.lightbox.hidden = false;
          this.lightbox.classList.add('is-entering');
          this.lightbox.offsetHeight;
          this.lightbox.classList.remove('is-entering');
          document.documentElement.style.overflow = 'hidden';
          this.lightboxClose.focus();
        };
        this.querySelectorAll('[data-lightbox-open]').forEach((slide) => {
          slide.addEventListener('click', () => {
            const img = slide.querySelector('img');
            if (!img) return;
            this.lightboxImg.src = img.currentSrc || img.src;
            this.lightboxImg.alt = img.alt || '';
            this.lightboxPanel.hidden = false;
            if (this.filmPanel) this.filmPanel.hidden = true;
            show(slide, 'Image viewer');
          });
        });
        const filmSlide = this.querySelector('[data-film-open]');
        if (filmSlide && this.filmVideo) {
          filmSlide.addEventListener('click', () => {
            this.lightboxPanel.hidden = true;
            this.filmPanel.hidden = false;
            if (this.ambient) this.ambient.pause();
            show(filmSlide, this.filmPanel.dataset.label || 'Film');
            // the click is the gesture, so the film may start with its sound
            this.filmVideo.play().catch(() => {});
          });
        }
        const close = () => {
          if (this.lightbox.hidden) return;
          // closing stops the film where it is; reopening picks it up there
          if (this.filmVideo) this.filmVideo.pause();
          this.lightbox.hidden = true;
          document.documentElement.style.overflow = '';
          if (this.ambient && this.ambientInView && this.ambient.classList.contains('is-playing')) {
            this.ambient.play().catch(() => {});
          }
          if (this.lightboxReturnFocus) this.lightboxReturnFocus.focus();
        };
        this.lightboxClose.addEventListener('click', close);
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox) close();
        });
        // a photograph holds one focusable control, so Tab stays on it; the
        // film holds two (close and the player) and Tab cycles between them
        this.lightbox.addEventListener('keydown', (e) => {
          if (e.key !== 'Tab') return;
          if (!this.filmPanel || this.filmPanel.hidden) {
            e.preventDefault();
            this.lightboxClose.focus();
            return;
          }
          const first = this.lightboxClose;
          const last = this.filmVideo;
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !this.lightbox.hidden) close();
        });
      }

      // V2.72: the film frame's muted loop (the Chariot Bundle's) plays only
      // while the frame is on screen, never under reduced motion, and stands
      // down while the film itself is open
      if (this.ambient && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.ambientInView = entry.isIntersecting;
            if (entry.isIntersecting && (!this.lightbox || this.lightbox.hidden)) {
              this.ambient.play().then(() => this.ambient.classList.add('is-playing')).catch(() => {});
            } else {
              this.ambient.pause();
            }
          });
        }, { threshold: 0.2 }).observe(this.ambient);
      }

      // off-screen carousel slides shouldn't take keyboard focus (desktop
      // transforms the track; mobile is a free scroll-snap strip)
      this.syncSlideFocus();
      this.desktop.addEventListener('change', () => this.syncSlideFocus());
    }

    syncSlideFocus() {
      this.slides.forEach((slide, i) => {
        const offscreen = this.desktop.matches && i !== this.index;
        slide.tabIndex = offscreen ? -1 : 0;
        slide.setAttribute('aria-hidden', offscreen ? 'true' : 'false');
      });
    }

    go(i) {
      const count = this.slides.length;
      this.index = ((i % count) + count) % count;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.thumbs.forEach((t) => t.classList.toggle('is-current', Number(t.dataset.thumb) === this.index));
      if (this.syncDesktopProgress) this.syncDesktopProgress();
      this.syncSlideFocus();
    }

    updateProgress() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const ratio = max > 0 ? this.track.scrollLeft / max : 0;
      const minPct = 28;
      this.progress.style.width = `${minPct + ratio * (100 - minPct)}%`;
    }
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  } catch(e) { console.error(e); }
})();
})();
